import request from '@/util/request';
import qs from 'qs';
//房产树一级节点
export const loadRoomTree1 = (params, options) =>
  request.get(
    '/api/propertyCharges/household/getVisibleTree',
    Object.assign({}, options, { params })
  );

//房产树一级节点
export const loadPayablePage = (params, options) =>
  request.get(
    '/api/v4ward/fund/bill/payablePage',
    Object.assign({}, options, { params })
  );


//房产树子节点
export const loadRoomTree2 = (params, options) =>
  request.get(
    '/api/propertyCharges/household/getChildrenNode',
    Object.assign({}, options, { params })
  );

//获取科目列表
export const getSubjectList = (params, options) =>
request.get('/api/v4ward/fee/subject/getSubjectList?status=1', Object.assign({}, options, { params }));

// //获取收费科目列表字典值
// export const getSubjectListByDict = (params, options) =>
// request.get('/api/v4ward/fee/subject/getSubjectList', Object.assign({}, options, { params }));


//住户信息
export const loadZhxx = (params, options) =>
  request.get(
    '/api/propertyCharges/household/getHouseholdByCodeOrId',
    Object.assign({}, options, { params })
  );

//小区下拉框
export const loadCommunityList = (params = {}, options = {}) =>
  request.get(
    "/api/v4ward/client/wx/public/communityList",
    Object.assign({}, options, { params })
  );

//小区下拉框
export const loadBuildingList = (params = {}, options = {}) =>
  request.get(
    "/api/v4ward/client/wx/public/buildingList",
    Object.assign({}, options, { params })
  );

//小区下拉框
export const loadRoomList = (params = {}, options = {}) =>
  request.get(
    "/api/v4ward/client/wx/public/roomList",
    Object.assign({}, options, { params })
  );


//小区下拉框
export const getPayTypeList = (params = {}, options = {}) =>
  request.get(
    "/api/propertyCharges/pay/paylist",
    Object.assign({}, options, { params })
  );

//小区下拉框
export const getPaySceneList = (params = {}, options = {}) =>
  request.get(
    "/api/v4ward/propertypay/v2/getPayScene",
    Object.assign({}, options, { params })
  );

//小区下拉框
export const getPaySceneListNew = (params = {}, options = {}) =>
  request.get(
    "/api/v4ward/propertypay/v1/getPayScene",
    Object.assign({}, options, { params })
  );


//物业收费二维码支付
export const saveQrCodePay = (params, options) =>
request.post('/api/v4ward/propertypay/v2/billpay', params, options);


//小区下拉框
export const loadPayStatusPlatform = (params = {}, options = {}) =>
  request.get(
    "/api/v4ward/propertypay/v2/queryplatform",
    Object.assign({}, options, { params })
  );

//小区下拉框
export const loadPayStatusChannel = (params = {}, options = {}) =>
  request.get(
    "/api/v4ward/propertypay/v2/querychannel",
    Object.assign({}, options, { params })
  );

  //小区下拉框
  export const loadPayStatusPlatformV1 = (params = {}, options = {}) =>
    request.get(
      "/api/v4ward/propertypay/v1/queryplatform",
      Object.assign({}, options, { params })
    );

  //小区下拉框
  export const loadPayStatusChannelV1 = (params = {}, options = {}) =>
    request.get(
      "/api/v4ward/propertypay/v1/querychannel",
      Object.assign({}, options, { params })
    );

//小区下拉框
export const getArrears = (params = {}, options = {}) =>
  request.get(
    "/api/v4ward/fund/bill/getArrears",
    Object.assign({}, options, { params })
  );

//小区下拉框
export const getCouponList = (params = {}, options = {}) =>
  request.get(
    "/api/v4ward/fund/preferent/getList",
    Object.assign({}, options, { params })
  );

//获取小区
export const getNode = (params, options) =>
    request.get('api/base/property/optionNode',
    Object.assign({}, options, { params })
  );

//获取小区
export const getVisibleTree = (params, options) =>
    request.get('api/base/property/optionNode',
    Object.assign({}, options, { params })
  );

//获取优惠政策
export const getPreferentList = (params, options) =>
    request.get('api/v4ward/fund/preferent/getList',
    Object.assign({}, options, { params })
  );

// 字典
export const getDict = (params, options) =>
    request.get('/api/blade-system/dict/dictionary', Object.assign({}, options, { params }));

//票据打印预览
export const billPrintPerv = (params, options) =>
  request.get('/api/v4ward/propertypay/v2/billprint/loadpayment', Object.assign({}, options, { params }));

//票据号检测
export const checkPayBillNo = (params, options) =>
  request.post('/api/v4ward/propertypay/v2/billprint/checkPayBillNo', Object.assign(params, options));

//票据打印-打印
export const billPrint = (params, options) =>
  request.post('/api/v4ward/propertypay/v2/billprint/submit', Object.assign(params, options));

//获取账单列表
export const getFeeBillList = (params, options) =>
  request.get('/api/v4ward/propertypay/v1/feeBill/list', Object.assign({}, options, { params }));

//获取账单列表
export const getTemppayItemsetList = (params, options) =>
  request.get('/api/v4ward/propertypay/v1/temppay/itemset/list', Object.assign({}, options, { params }));

//获取账单列表
export const getGenerateItemsetList = (params, options) =>
  request.get('/api/v4ward/propertypay/v1/generate/itemset/list', Object.assign({}, options, { params }));

//查询优惠券
export const queryCouponCode = (params, options) =>
  request.get('/api/v4ward/propertypay/v1/queryCouponCode', Object.assign({}, options, { params }));

//获取账单列表
export const getGenerateEnddate = (params, options) =>
  request.get('/api/v4ward/propertypay/v1/generate/enddate', Object.assign({}, options, { params }));

//获取账单列表
export const generateFeeBill = (params, options) =>
  request.post('/api/v4ward/propertypay/v1/feeBill/generate', Object.assign(params, options));

//获取账单列表
export const getTemppayInfo = (params, options) =>
  request.get('/api/v4ward/propertypay/v1/temppay/info', Object.assign({}, options, { params }));

//获取户主欠费金额
export const getArrearsExtendtion = (params, options) =>
  request.get('/api/v4ward/propertypay/v1/feeBill/arrears', Object.assign({}, options, { params }));

//获取账单信息
export const getAccountSearch = (params = {}, options = {}) =>
  request.get('/api/v4ward/fund/bill/page',
    Object.assign({}, options, { params })
  );

  //获取账单历史
export const getBillSearch = (params = {}, options = {}) =>
request.get('/api/v4ward/fund/pay/historyPage',
  Object.assign({}, options, { params })
);

 //获取户主房屋信息
 export const getHouseholderRoomInfo = (params = {}, options = {}) =>
request.get('/api/base/property/getHousenholdById',
  Object.assign({}, options, { params })
);

export const getStandardByTargetId = (params, options) =>
  request.get('/api/v4ward/fee/standard/listByTargetId', Object.assign({}, options, { params }));


//临时收费二维码支付
export const saveQrCodePayTemp = (params, options) =>
request.post('/api/v4ward/propertypay/v2/temporarypay', params, options);

//获取户主信息
export const getHouseholderInfo = (params = {}, options = {}) =>
request.get('/api/base/household/getHouseholdByPropertyId',
  Object.assign({}, options, { params })
);

//票据打印预览
export const billPrintPervNew = (params, options) =>
  request.get('/api/v4ward/propertypay/v2/billprint/loadpayment', Object.assign({}, options, { params }));


//票据打印保存
export const billPrintSaveNew = (params, options) =>
  request.post('/api/v4ward/propertypay/v2/billprint/save', Object.assign(params, options));

  //票据打印更新
  export const billPrintUpdateNew = (params, options) =>
    request.post('/api/v4ward/propertypay/v2/billprint/update', Object.assign(params, options));

//获取优惠规则
export const getFavouredPolicy = (params = {}, options = {}) =>
request.get('/api/v4ward/fund/preferent/gettPreferentList',
  Object.assign({}, options, { params })
);
//票据打印预览
export const getGenerateEnddateNew = (params, options) =>
  request.get('/api/v4ward/propertypay/v2/getBillEndTime', Object.assign({}, options, { params }));


//票据打印保存
export const generateFeeBillNew = (params, options) =>
  request.post('/api/v4ward/propertypay/v2/generateBill', Object.assign(params, options));


//票据打印保存
// export const checkPayBillNoNew = (params, options) =>
//   request.post('/api/v4ward/propertypay/v2/billprint/checkPayBillNo', Object.assign(params, options));

//票据打印保存
export const checkPayBillNoNew = (params, options) =>
  request.get('/api/v4ward/propertypay/v2/billprint/checkPayBillNo', Object.assign({}, options, { params }));


//票据打印预览
export const calculatePreferent = (params, options) =>
  request.post('/api/v4ward/fund/preferent/calculate', Object.assign(params, options));

//获取收费科目
export const getBindSubjectByTargetId = (params, options) =>
  request.get('/api/v4ward/fee/standard/bind/getBindSubjectByTargetId', Object.assign({}, options, { params }));


//票据打印预览
export const billPayNewSubmit = (params, options) =>
  request.post('/api/v4ward/propertypay/v1/billpay', Object.assign(params, options));

//获取欠费信息
export const getFeeBillOweDesc = (params, options) =>
  request.get('/api/v4ward/propertypay/v1/feeBill/owe/desc', Object.assign({}, options, { params }));

//获取欠费信息
export const getCommunityGroupList = (params, options) =>
  request.get('/api/base/property/common/communityGroup', Object.assign({}, options, { params }));

//获取欠费信息
export const getPayBillList = (params, options) =>
  request.get('/api/fee-pay-list/feepaylist/payBill/Page', Object.assign({}, options, { params }));

 // 收费管理-减免
export const reduction = (params, options) =>
  request.post('/api/v4ward/propertypay/v1/reduction', Object.assign({}, params, options));

// 收费管理-销账
export const offBill = (params, options) =>
  request.post('/api/v4ward/propertypay/v1/write-off', Object.assign({}, params, options));

// 收费管理-获取业务单号
export const getBusinessNo = (params, options) =>
  request.get('/api/v4ward/propertypay/v1/businessNo', Object.assign({}, options, { params }));

//获取账单列表
export const areaChangeBillList = (params, options) =>
  request.get('/api/v4ward/propertypay/v1/feeBill/list-area', Object.assign({}, options, { params }));

//重新计算账单信息
export const areaChangeBillListReCalc = (params, options) =>
  request.get('/api/v4ward/propertypay/v1/feeBill/area-re-calc', Object.assign({}, options, { params }));

//提交面积变更
export const areaChangeSubmit = (params, options) =>
  request.post('/api/v4ward/propertypay/v1/feeBill/area-change-submit', Object.assign({}, params, options));
